import { useHistory } from 'react-router';

import React, { useState } from 'react';
import { action } from '../../lib/actionHelpers.js';
import selectors from '../../selectors/selectors.js';
import { useSelector } from 'react-redux';
import sortByProp from '../../lib/sortByProp.js';
import PillSelect from '../PillSelect.js';
import { getServiceProvider } from '../../redux/actions/serviceProviderActions';
import getDefaultUserRoute from '../../lib/getDefaultUserRoute';

const AppHeaderServiceProviderDropdown = () => {
  const history = useHistory();
  const [loadingServiceProvider, setLoadingServiceProvider] = useState(false);
  const serviceProviders = (useSelector(selectors.userServiceProviders) || []).sort(sortByProp('name')).filter((n) => n.active !== '0');
  const serviceProviderId = useSelector((state) => state.currentServiceProvider.id);
  const tresioUser = useSelector((state) => state.user.tresioUser);
  return (
    <PillSelect
      className={'service-provider-dropdown'}
      options={serviceProviders.map((n) => ({ id: n.id, label: n.name }))}
      value={loadingServiceProvider ? 'Loading...' : serviceProviderId}
      freeform={loadingServiceProvider}
      onChange={(n) => {
        setLoadingServiceProvider(true);
        getServiceProvider(n.id, (data) => {
          action('uiPatchFilters', { userId: null });
          setLoadingServiceProvider(false);
          history.push(getDefaultUserRoute(n.id, [data], data, tresioUser));
        });
      }}
    />
  );
};

export default AppHeaderServiceProviderDropdown;
